module.exports = __webpack_public_path__ + "media/images/points_1-310cdd3e20509155c2abd274e08cdd97.svg";